import type { MessagingGetChatRoomById200ParticipantsItemBasicInfo } from './messagingGetChatRoomById200ParticipantsItemBasicInfo';
import type { MessagingGetChatRoomById200ParticipantsItemSocial } from './messagingGetChatRoomById200ParticipantsItemSocial';

/**
 * 간략한 사용자 정보
 */
export type MessagingGetChatRoomById200ParticipantsItem = {
  /** 사용자 기본 정보 */
  basicInfo: MessagingGetChatRoomById200ParticipantsItemBasicInfo;
  /** 소셜 관계 정보 */
  social?: MessagingGetChatRoomById200ParticipantsItemSocial;
};
